export default {
	i18n: require('./i18n').default,
	methods: {
		click() {
			this.$emit('click');
		}
	}
};
